import { render, staticRenderFns } from "./RepairDetail2.vue?vue&type=template&id=0b9ade52&"
import script from "./RepairDetail2.vue?vue&type=script&lang=js&"
export * from "./RepairDetail2.vue?vue&type=script&lang=js&"
import style0 from "./RepairDetail2.vue?vue&type=style&index=0&id=0b9ade52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports